@if (
  {
    row: columnData | async,
    aData: additionData | async,
  };
  as $
) {
  @if ($.row && $.aData && !isEmptyAndNull($.row[$.aData.fetch_key])) {
    <span> {{ getServiceValidity($.row[$.aData.fetch_key]) | async }}</span>
  } @else {
    -
  }
}
